import { render, staticRenderFns } from "./AdSetup.vue?vue&type=template&id=261db9d5&"
import script from "./AdSetup.vue?vue&type=script&lang=js&"
export * from "./AdSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports